import Container from "@components/ui-old/container";
import Layout from "@components/layout/layout";
import PageHeader from "@components/ui-old/page-header";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next";
import React, { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import CounterSection from "@components/about/counter-section";
//import TeamSection from "@components/about/team-section";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import VideoSection from "@components/about/video-section";
import Tabs from "@components/about/tab";
import Divider from "@components/other/divider";
import GoldIcon from "@components/Svg/gold-icon";
import { WordPullUp } from "@components/ui/word-pull-up";
import LoadingCarousel from "@components/ui/loading-carousel";
import CertificateIcons from "@components/about/certificate-icons";
import { NextSeo } from "next-seo";
import { siteSettings } from "@settings/site-settings";
import { CardCarousel } from "@components/ui/card-carousel";
import AboutOurLeadership from "@components/about/our-leadership";
interface Counter {
  id: string;
  number: number;
  symbol: string;
  title: string;
}
export default function AboutUs() {
  const {
    t
  } = useTranslation();
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const leaders = {
    items: [{
      position: "CEO",
      name: "Gregg Maughan",
      image: "gregg-maughan.jpg"
    }, {
      position: "President",
      name: "Aidan O'Hare",
      image: "aidan-ohare.jpg"
    }, {
      position: "President / Aloe Vera of America",
      name: "Gary Shreeve",
      image: "gary-shreeve.jpg"
    }, {
      position: "Executive Vice President / the Americas",
      name: "Garin Breinholt",
      image: "garin-breinholt.jpg"
    }, {
      position: "Executive Vice President / Finance & Treasurer",
      name: "Dave Hall",
      image: "dave-hall.jpg"
    }, {
      position: "Executive Vice President / Taxation",
      name: "Rhonda Krause",
      image: "rhonda-krause.jpg"
    }, {
      position: "Executive Vice President / Legal / General Counsel",
      name: "Darin Reber",
      image: "darin-reber.jpg"
    }, {
      position: "Senior Vice President / Operations",
      name: "Bill Lewis",
      image: "bill-lewis.jpg"
    }, {
      position: "Senior Vice President / Communications",
      name: "Nick Woodward-Shaw",
      image: "nick-woodward-shaw.jpg"
    }, {
      position: "Senior Vice President of Human Resources",
      name: "Melissa Sunderland",
      image: "melissa-sunderland.jpg"
    }, {
      position: "Senior Vice President / Digital & Information Technology",
      name: "Rob Ferguson",
      image: "rob-ferguson.jpg"
    }, {
      position: "Vice President / Product Development",
      name: "Holly Stout",
      image: "holly-stout.jpg"
    }, {
      position: "Vice President / Asia",
      name: "CG Tan",
      image: "cg-tan.jpg"
    }, {
      position: "Vice President / Africa",
      name: "Jean Baptiste Amichia",
      image: "jean-baptiste-amichia.jpg"
    }, {
      position: "Vice President / Europe",
      name: "Peter Boots",
      image: "peter-boots.jpg"
    }, {
      position: "Vice President / Strategic Management",
      name: "Yves Hamon",
      image: "yves-hamon.jpg"
    }, {
      position: "Vice President / Latin America",
      name: "Ramses Acosta",
      image: "ramses-acosta.jpg"
    }, {
      position: "Vice President / Middle East",
      name: "İlker İşmen",
      image: "ilker-ismen.jpg"
    }]
  };
  const counters: Counter[] = [{
    id: "counter1",
    number: 47,
    symbol: "+",
    title: t("common:text-counter-1")
  }, {
    id: "counter2",
    number: 140,
    symbol: "+",
    title: t("common:text-counter-2")
  }, {
    id: "counter3",
    number: 10000000,
    symbol: "+",
    title: t("common:text-counter-3")
  }, {
    id: "counter4",
    number: 220,
    symbol: "+",
    title: t("common:text-counter-4")
  }];
  useEffect(() => {
    const checkIsMobile = () => {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {}
    };
    checkIsMobile();
    const handleScroll = () => {
      if (window.scrollY >= 2100 && !isScrolled) {
        setIsScrolled(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);
  return <>
      <NextSeo title={`${t('menu:menu-forever-about') || "About Us"} - ${siteSettings.name}`} description={t('common:aboutus-description') || "Forever Living Product"} canonical={`${siteSettings.author.websiteUrl}forever/about-us`} openGraph={{
      url: `${siteSettings.author.websiteUrl}forever/about-us`,
      title: `${t('menu:menu-forever-about') || "About Us"} - ${siteSettings.name}`,
      description: t('common:aboutus-description') || "Forever Living Product",
      images: [{
        url: `${siteSettings.author.websiteUrl}assets/images/og-image-01.png`,
        width: 1200,
        height: 630,
        alt: `${t("menu:menu-forever-about")}`
      }],
      site_name: siteSettings.name
    }} twitter={{
      handle: "@handle",
      site: "@site",
      cardType: "summary_large_image"
    }} data-sentry-element="NextSeo" data-sentry-source-file="about-us.tsx" />
      <PageHeader pageHeader="text-page-about" pageSubHeader="text-page-about-sub" data-sentry-element="PageHeader" data-sentry-source-file="about-us.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="about-us.tsx">
        <div className="py-16 lg:py-20 px-0 max-w-6xl mx-auto">
          <span className="flex justify-center items-center mx-2 rounded-full p-2">
            <GoldIcon style={{
            width: '48px',
            height: '48px'
          }} data-sentry-element="GoldIcon" data-sentry-source-file="about-us.tsx" />
          </span>
          <WordPullUp className="text-2xl font-bold tracking-[-0.02em] text-neutral-900 dark:text-neutral-100 md:text-4xl md:leading-[5rem] my-4" words={t('common:text-look-better')} data-sentry-element="WordPullUp" data-sentry-source-file="about-us.tsx" />
          <VideoSection data-sentry-element="VideoSection" data-sentry-source-file="about-us.tsx" />
          <Divider icon={GoldIcon} data-sentry-element="Divider" data-sentry-source-file="about-us.tsx" />
          <Tabs data-sentry-element="Tabs" data-sentry-source-file="about-us.tsx" />
          <Divider icon={GoldIcon} data-sentry-element="Divider" data-sentry-source-file="about-us.tsx" />
          <WordPullUp className="text-2xl font-bold tracking-[-0.02em] text-neutral-900 dark:text-neutral-100 md:text-4xl md:leading-[5rem] my-4" words={t('common:text-we-forever')} data-sentry-element="WordPullUp" data-sentry-source-file="about-us.tsx" />
          <LoadingCarousel autoplayInterval={5000} showNavigation={true} data-sentry-element="LoadingCarousel" data-sentry-source-file="about-us.tsx" />
          <Divider icon={GoldIcon} data-sentry-element="Divider" data-sentry-source-file="about-us.tsx" />
          <WordPullUp className="text-2xl font-bold tracking-[-0.02em] text-neutral-900 dark:text-neutral-100 md:text-4xl md:leading-[5rem] my-6" words={t('common:text-leadership')} data-sentry-element="WordPullUp" data-sentry-source-file="about-us.tsx" />
          <CardCarousel images={leaders.items.map(leader => ({
          src: leader.image,
          alt: leader.name,
          name: leader.name,
          position: leader.position
        }))} data-sentry-element="CardCarousel" data-sentry-source-file="about-us.tsx" />
          <AboutOurLeadership data-sentry-element="AboutOurLeadership" data-sentry-source-file="about-us.tsx" />
          <Divider icon={GoldIcon} data-sentry-element="Divider" data-sentry-source-file="about-us.tsx" />
          <CounterSection counters={counters} data-sentry-element="CounterSection" data-sentry-source-file="about-us.tsx" />
          <CertificateIcons data-sentry-element="CertificateIcons" data-sentry-source-file="about-us.tsx" />
        </div>
      </Container>
    </>;
}
AboutUs.Layout = Layout;
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ["common", "forms", "menu", "faq", "footer", 'swal']))
    }
  };
};